

import Papa from "papaparse";
import { toast } from "react-toastify";
import axios from "axios";
import { handleError } from "./AuthenticationCheck";

export const downloadCSVFromApi = async (
    apiUrl,
    payload, // Don't modify this payload
    accessToken,
    options = {}
) => {
    const {
        filename = `download_${new Date().toISOString().split('T')[0]}.csv`,
        navigate,
        method = "GET", // Change default to GET
        useBearerToken = true, // Your other calls use Bearer
    } = options;

    try {
        toast.info("Downloading please wait...");

        // Prepare headers
        const headers = {
            "Content-Type": "application/json",
            Accept: "text/csv",
        };

        // Add appropriate authentication header
        if (useBearerToken) {
            headers.Authorization = `Bearer ${accessToken}`;
        } else {
            headers.logintoken = accessToken;
        }

        // DON'T modify the payload here - use it as is
        // Your payload already has download: true from the component
        let response;

        if (method.toUpperCase() === "GET") {
            response = await axios.get(apiUrl, {
                params: payload, // Pass payload as query params
                headers,
                withCredentials: true,
                responseType: "blob",
            });
        } else {
            response = await axios.post(apiUrl, payload, {
                headers,
                withCredentials: true,
                responseType: "blob",
            });
        }

        // Create download link for the blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        toast.success("CSV downloaded successfully!");

    } catch (error) {
        console.error("Download error:", error);

        // Handle blob errors
        if (error.response && error.response.data instanceof Blob) {
            try {
                const errorText = await error.response.data.text();
                const errorData = JSON.parse(errorText);

                const enhancedError = {
                    response: {
                        status: error.response.status,
                        data: errorData
                    }
                };

                handleError(enhancedError, navigate);
            } catch {
                handleError(error, navigate);
            }
        } else {
            handleError(error, navigate);
        }
    }
};